import { SLOT_NAMES, collageLayout, type Item } from '@closetly/core';
import { storedImageUrl } from '../lib/image';

/** An outfit as one picture: pieces placed by the layout for their count, the first one big. */
export function Collage({
  pieces,
  big = false,
}: {
  pieces: Pick<Item, 'id' | 'name' | 'image' | 'category'>[];
  big?: boolean;
}) {
  const layout = collageLayout(pieces.length);
  const shown = pieces.slice(0, layout.slots);
  const more = pieces.length - shown.length;

  return (
    <div
      className="collage"
      style={{
        gridTemplateAreas: layout.areas,
        gridTemplateColumns: layout.columns,
        gridTemplateRows: layout.rows,
        aspectRatio: layout.aspect,
      }}
    >
      {shown.length === 0 ? (
        <div className="slot empty" style={{ gridArea: 'a' }}>
          Noch keine Teile
        </div>
      ) : (
        shown.map((p, i) => {
          const src = storedImageUrl(p, big || i === 0 ? '800x0' : '400x0');
          const rest = i === shown.length - 1 && more > 0 ? more : 0;
          return (
            <div key={p.id} className={`slot${src ? '' : ' text'}`} style={{ gridArea: SLOT_NAMES[i] }}>
              {src ? (
                <img src={src} alt={p.name} loading="lazy" />
              ) : (
                <span>
                  <b>{p.name}</b>
                  <small>{p.category}</small>
                </span>
              )}
              {rest > 0 && <span className="more">+{rest}</span>}
            </div>
          );
        })
      )}
    </div>
  );
}
